<template lang="pug">
    .log-nutrition
      .log-nutrition-content
        .log-nutrition-header How would you describe your food choices?
        .enter-nutrition-input
          .nutrition-option-container
            .multiline-radio
                BRadio(
                    v-for="option in nutritionOptions"
                    :key="option.value"
                    v-model="nutrition"
                    :native-value="option.value"
                ) {{ option.label }}
        .save-button
          WtButton(
            @click.native="saveEntry"
            :loading="savingnutrition"
            :disabled="!isValid"
          ) Next
  </template>

<script>
import { mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "Lognutrition",

  components: {
    WtTitle,
    WtButton,
    WtSvgIcon
  },

  mixins: [analyticsTrackingMixin, dateUtilityMixin],

  props: {
    uniqueKey: {
      type: String,
      default: null
    },

    entryItem: {
      type: Object,
      default: () => ({}),
      required: true
    },

    entryDate: {
      type: String,
      default: ""
    },

    formData: {
      type: FormData,
      required: true
    },

    saveEntryWrapper: {
      type: Function,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      nutrition: 0,
      savingnutrition: false,
      nutritionOptions: [
        { value: 10, label: "Very healthy" },
        { value: 8, label: "Mostly healthy" },
        { value: 6, label: "Balanced" },
        { value: 4, label: "Somewhat unhealthy" },
        { value: 2, label: "Mostly unhealthy" }
      ]
    };
  },

  computed: {
    currentMetricValue() {
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: "nutrition"
      });
      return this._.get(metric, "value", 0);
    },

    setFormData() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.sessions !== this.currentMetricValue ||
          this.formData.has("nutrition")
        );
      }
      return true;
    },
    isValid() {
      return this.nutrition;
    }
  },

  watch: {
    nutrition() {
      if (this.setFormData) {
        this.formData.set("nutrition", this.nutrition);
        this.$emit("formDataUpdated", true);
      }
    },

    entryItem: {
      handler() {
        this.nutrition = this.currentMetricValue;
      },
      immediate: true,
      deep: true
    },

    // Watch for uniqueKey changes to reset the form when switching dates
    uniqueKey: {
      handler() {
        this.nutrition = this.currentMetricValue;
      },
      immediate: true
    }
  },

  mounted() {
    this.trackFeatureView("tracking", "tracking_nutrition");
    this.nutrition = this.currentMetricValue;
  },

  methods: {
    ...mapActions("members", ["storeJournal", "updateJournal"]),

    saveEntry() {
      // Always send the value so the backend links the post to this metric
      this.formData.set("nutrition", this.nutrition);

      this.savingnutrition = true;
      this.saveEntryWrapper(this.storeJournal, this.updateJournal).finally(
        () => {
          this.savingnutrition = false;
        }
      );
    },

    reset() {
      const item = "nutrition";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      this.steps = this.currentMetricValue;
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.log-nutrition
  height: 100%
  display: flex
  flex-direction: column
  justify-content: space-between

.log-nutrition-content
  flex: 1
  flex-direction: column
  display: flex
  justify-content: center
  align-items: center
  gap: 20px

  .log-nutrition-header
    width: 100%
    text-align: left
    font-weight: 600
    font-size: 20px
    line-height: 28px
    letter-spacing: 0px
    color: #1B1D20

  .enter-nutrition-input
    width: 100%

  .nutrition-option-container
    display: flex

    ::v-deep .multiline-radio
        width: 100%
        display: flex
        flex-direction: column
        gap: 10px
        margin: 0rem

    ::v-deep .b-radio.radio
        outline: none
        display: inline-flex
        align-items: center
        justify-content: flex-start
        border-radius: 12px
        border: 1px solid #F1F3F8
        padding: 12px

    ::v-deep  .b-radio.radio:not(.button)
        margin-right: 0

  .save-button
    width: 100%

    ::v-deep .button
      width: 100% !important
      justify-content: center
      font-size: 16px
      line-height: 24px
      letter-spacing: 0px


.centered-input ::v-deep input
  text-align: center !important
  font-size: 28px
  line-height: 36px
  letter-spacing: -1%
  font-weight: 500
  color: #5D6472

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    display: none
</style>
